import type { Viewer3DPublishableKey } from "../types"

export type Viewer3DKeysList = { items: Viewer3DPublishableKey[] }

/**
 * The create/update-origins endpoints return the full authoritative key record
 * (origins already passed through `withPlatformOrigins` server-side), so the
 * cached list can be patched straight from the response instead of paying a
 * second round-trip through a cold Lambda — which is what made a saved rename
 * show the pre-save origins for ~2s (Asana 1216941879631463 follow-up).
 *
 * `previous` is optional for the same reason as in `viewer3DListCache.ts`: a
 * disabled query registers a cache entry whose data is `undefined`.
 */
export const upsertViewer3DKey = (
  previous: Viewer3DKeysList | undefined,
  key: Viewer3DPublishableKey
): Viewer3DKeysList | undefined => {
  if (!previous) return previous
  if (!previous.items.some((item) => item.keyHash === key.keyHash))
    // Unknown hash = create. Order is irrelevant: the page re-sorts by createdAt.
    return { ...previous, items: [...previous.items, key] }

  return {
    ...previous,
    items: previous.items.map((item) => (item.keyHash === key.keyHash ? key : item)),
  }
}

export const removeViewer3DKey = (
  previous: Viewer3DKeysList | undefined,
  keyHash: string
): Viewer3DKeysList | undefined => {
  if (!previous) return previous
  if (!previous.items.some((item) => item.keyHash === keyHash)) return previous
  return { ...previous, items: previous.items.filter((item) => item.keyHash !== keyHash) }
}
